import './style.css'
import * as dat from 'lil-gui'
import * as THREE from 'three'
import gsap from 'gsap'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js'
import { FilmPass } from 'three/examples/jsm/postprocessing/FilmPass.js'
import { CopyShader } from 'three/examples/jsm/shaders/CopyShader.js'



/**
 * Base
 */

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Loaders
 */

// Texture loader
const textureLoader = new THREE.TextureLoader()

// GLTF loader
const gltfLoader = new GLTFLoader()


/**
 * Textures
 */ 

const bakedTexture = textureLoader.load('baked.jpg')
bakedTexture.flipY = false

const bakedTextureN = textureLoader.load('bakedNight.jpg')
bakedTextureN.flipY = false

const bakedTextureG = textureLoader.load('bakedGradient.jpg')
bakedTextureG.flipY = false

const bakedTextureG2 = textureLoader.load('bakedGradient2.jpg')
bakedTextureG2.flipY = false

const bakedTextureG3 = textureLoader.load('bakedGradient3.jpg')
bakedTextureG3.flipY = false

const bakedTextureBW = textureLoader.load('bakedBW.jpg')
bakedTextureBW.flipY = false


/**
 * Materials
 */
const roomMaterial = new THREE.MeshBasicMaterial({ map: bakedTexture })

const roomMaterialN = new THREE.MeshBasicMaterial({ map: bakedTextureN })

const roomMaterialG = new THREE.MeshBasicMaterial({ map: bakedTextureG })

const roomMaterialG2 = new THREE.MeshBasicMaterial({ map: bakedTextureG2 })

const roomMaterialG3 = new THREE.MeshBasicMaterial({ map: bakedTextureG3})

const roomMaterialBW = new THREE.MeshBasicMaterial({ map: bakedTextureBW})

/**
 * Infinity Rooms
 */
gltfLoader.load(
    'room.gltf',
    (gltf) =>
    {
        const roomMesh = null
        const dummy = new THREE.Object3D()
        const sectionWidth = 330
        
        const roomScene = gltf.scene.children.find((child) => child.name === 'room')

        // Infinity Rooms
        function addInstancedMesh()
        {
            
            const roomClone = roomScene.geometry.clone()
            const roomMesh = new THREE.InstancedMesh(roomClone, roomMaterial, 35)
            roomMesh.scale.set(0.008, 0.008, 0.008)
            roomMesh.position.z = -12
            scene.add(roomMesh)

            window.addEventListener('click', () =>
            {
                if(roomMesh.material == roomMaterial)
                {
                    roomMesh.material = roomMaterialN
                }
                else if(roomMesh.material == roomMaterialN)
                {
                    roomMesh.material = roomMaterialG
                }
                else if(roomMesh.material == roomMaterialG) 
                {
                    roomMesh.material = roomMaterialG2
                }
                else if(roomMesh.material == roomMaterialG2) 
                {
                    roomMesh.material = roomMaterialG3
                }
                else if(roomMesh.material == roomMaterialG3) 
                {
                    roomMesh.material = roomMaterialBW
                }
                else
                {
                    roomMesh.material = roomMaterial
                }
            })
            

            setInstancedMeshPositions(roomMesh)
        }
        

        function setInstancedMeshPositions(roomMesh) 
        {
            for ( var i = 0; i < roomMesh.count; i ++ ) {
              var zStaticPosition = -sectionWidth * (i - 1) * 7.06
              dummy.position.set(0, 0, zStaticPosition)
              dummy.updateMatrix()
              roomMesh.setMatrixAt(i, dummy.matrix)

            }
            roomMesh.instanceMatrix.needsUpdate = true
          }

          
          addInstancedMesh()
    }
    
)


/**
 * Sizes
 */
const sizes = {
    width: 800,
    height: 850
}

window.addEventListener('resize', () =>
{ 
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()


    // // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    // // Update effect composer
    effectComposer.setSize(sizes.width, sizes.height)
    effectComposer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

})


/**
 * Camera
 */
const camera = new THREE.PerspectiveCamera(40, sizes.width / sizes.height, 0.1, 1000)
camera.position.x = 0.015
camera.position.y = 0
camera.position.z = 0
scene.add(camera)

// Cursor
const cursor = {
    x: 0,
    y: -0.5
}

window.addEventListener('keypress', () =>
{
    window.addEventListener('mousemove', (event) =>
    {
        cursor.x = event.clientX / sizes.width - 0.5
        cursor.y = - (event.clientY / sizes.height - 0)
    })
})

/**
 * Renderer
 */
 const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    powerPreference: 'high-performance'
})

renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
// renderer.outputEncoding = THREE.sRGBEncoding

/**
 * Render Target
 */
const renderTarget = new THREE.WebGLRenderTarget(
    800,
    850,
    {
        samples: 6
    }
)


/**
 * Post processing
 */

const effectComposer = new EffectComposer(renderer, renderTarget)
effectComposer.setSize(sizes.width, sizes.height)
effectComposer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

const renderPass = new RenderPass(scene, camera)
effectComposer.addPass(renderPass)

const filmPass = new FilmPass(0.35, 0.015, 680, false)
effectComposer.addPass(filmPass)

/**
 * Animate
 */
gsap.to(camera.position, {duration: 10, z: -18.61, ease: "none", repeat: -1})

const tick = () =>
{
    // const elapsedTime = clock.getElapsedTime()

    // Render
    // renderer.render(scene, camera)
    effectComposer.render()

    // Call loop again on the next frame
    window.requestAnimationFrame(tick)

    // Update camera
    camera.position.x = cursor.x
    camera.position.y = cursor.y


}

tick()
